<template>
  <a-drawer
    class="part drawer marketing-campaign"
    width="700"
    title="New Campaign"
    placement="right"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <div class="inner">
      <CampaignForm @submit="onSubmit" />
    </div>
    <!-- {{ campaign }} -->
  </a-drawer>
</template>
<script>
import { CampaignForm } from '@/components/reno/forms'

const KEY = 'CREATE_CAMPAIGN'

export default {
  components: {
    CampaignForm,
  },
  name: 'marketing-campaign-drawer',
  data() {
    return {}
  },
  computed: {
    campaign() {
      return this.$store.getters['marketing/data']('campaign')
    },
    visible: {
      get() {
        return this.$store.getters['marketing/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('marketing/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async onSubmit(valid_campaign) {
      if (valid_campaign) {
        const new_campaign = await this.$store.dispatch('marketing/createCampaign', valid_campaign)
        this.visible = false
      }
    },
    afterVisibleChange(val) {
      // NOTHING
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer.marketing-campaign {
  .inner {
    max-width: 750px;
    margin: 0 auto;
  }
}
</style>
